'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;

function hideToTopButton() {
    $('#to-top-button').css('opacity', '0');
}

function showToTopButton() {
    $('#to-top-button').css('opacity', '1');
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }

    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 1500);

    var $targetElement = $('a[data-pid="' + data.pid + '"]')
        .closest('.product-info')
        .find('.remove-product');

    var itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid')
    };

    $('body').trigger('afterRemoveFromCart', itemToMove);

    setTimeout(function () {
        $('.cart.cart-page #removeProductModal').modal();
    }, 2000);
}

module.exports = function () {
    cart();

    // --- iOS-safe body scroll lock ---
    var __scrollY = 0;
    var __bodyLocked = false;

    function lockBodyScroll() {
        if (__bodyLocked) return;
        __bodyLocked = true;

        __scrollY = window.scrollY || window.pageYOffset || 0;
        $('body').addClass('no-scroll').css('top', -__scrollY + 'px');
    }

    function unlockBodyScroll() {
        if (!__bodyLocked) return;
        __bodyLocked = false;

        $('body').removeClass('no-scroll').css('top', '');
        window.scrollTo(0, __scrollY);
    }

    /**
     * Fælles helper til at opdatere ikon/tæller
     * Bruger både på .minicart, .minicartFly og .minicart-total
     */
    function applyMiniCartCount(qty, label) {
        if (!$.isNumeric(qty)) return;

        label = label || ('Kurv ' + qty + (qty === 1 ? ' vare' : ' varer'));

        $('.minicart, .minicartFly, .minicart-total').each(function () {
            var $root = $(this);
            var $qty = $root.find('.minicart-quantity');
            if ($qty.length) $qty.text(qty);

            var $link = $root.find('.minicart-link');
            if ($link.length) {
                $link.attr({ 'aria-label': label, title: label });
            }
        });
    }

    function reloadMiniCartCount() {
        var $source = $('.minicartFly').length ? $('.minicartFly') : $('.minicart');
        if (!$source.length) return;

        var url = $source.data('action-url');
        if (!url) return;

        $.get(url, function (html) {
            var $html = $(html);
            var $qtyEl = $html.find('.minicart-quantity').first();

            var qty = 0;
            if ($qtyEl.length) {
                var text = $.trim($qtyEl.text());
                var parsed = parseInt(text, 10);
                if (!isNaN(parsed)) qty = parsed;
            }

            var label = 'Kurv ' + qty + (qty === 1 ? ' vare' : ' varer');
            applyMiniCartCount(qty, label);
        });
    }

    // ---------------------------------------
    // NORMAL MINICART (dropdown)
    // ---------------------------------------
    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            var qty = count.quantityTotal;
            var label = count.minicartCountOfItems ||
                ('Kurv ' + qty + (qty === 1 ? ' vare' : ' varer'));
            applyMiniCartCount(qty, label);
        }
    });

    $('.minicart').on('mouseenter focusin touchstart', function () {
        if ($('.search:visible').length === 0) return;

        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('.minicart .popover').addClass('show');
                return;
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();

            $.get(url, function (data) {
                $('.minicart .popover').empty().append(data);
                updateMiniCart = false;
                $.spinner().stop();
            });
        }
    });

    $('body').on('touchstart click', function (e) {
        if ($('.minicart').has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });

    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicart .popover').removeClass('show');
    });

    // -------------------------------------------------
    // Helper: Åbn fly-in-kurven
    // -------------------------------------------------
    function openMiniCartFly(force) {
        if (!force && $('.search:visible').length === 0) return;

        var $mini = $('.minicartFly');
        if (!$mini.length) return;

        var url = $mini.data('action-url');
        var count = parseInt($mini.find('.minicart-quantity').text(), 10);

        if (!url || (!force && count === 0)) return;

        var $popover = $mini.find('.popover');

        if ($popover.hasClass('show') && !updateMiniCart) {
            $('.cart-backdrop').addClass('active');
            hideToTopButton();
            lockBodyScroll();
            openCart();
            return;
        }

        $popover.addClass('show');
        $('.cart-backdrop').addClass('active');
        hideToTopButton();
        lockBodyScroll();
        $popover.spinner().start();

        $.get(url, function (data) {
            const $popoverInner = $('.minicartFly .popover');
            $popoverInner.empty().append(data);
            $('.move').clone(true).appendTo('.moveto').show();
            $('.movecard').clone(true).appendTo('.movecardto').show();
            updateMiniCart = false;
            $.spinner().stop();

            const $tp = $popoverInner.find('.trustpilot-widget');

            (function initTrustpilot(tries) {
                tries = typeof tries === 'number' ? tries : 20;
                if ($tp.length && window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
                    window.Trustpilot.loadFromElement($tp[0], true);
                } else if (tries > 0) {
                    setTimeout(function () { initTrustpilot(tries - 1); }, 150);
                }
            })(20);
        });

        openCart();
    }

    // -------------------------------------------------
    // FLY IN CART START
    // -------------------------------------------------
    $('.minicartFly').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            var qty = count.quantityTotal;
            var label = count.minicartCountOfItems ||
                ('Kurv ' + qty + (qty === 1 ? ' vare' : ' varer'));
            applyMiniCartCount(qty, label);
        }
    });

    $('.minicartFly').on('mouseenter focusin touchstart', function () {
        openMiniCartFly(false);
    });

    // Luk fly-in ved klik udenfor (og lås op igen)
    $('body').on('touchstart click', function (e) {
        if ($('body').hasClass('modal-open') || $(e.target).closest('.modal').length) return;

        if ($('.minicartFly').has(e.target).length <= 0) {
            $('.minicartFly .popover').removeClass('show');
            $('.cart-backdrop').removeClass('active');
            unlockBodyScroll();
            if (typeof closeCart === 'function') closeCart();
        }
    });

    $('.minicartFly').on('focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicartFly').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicartFly .quantity'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicartFly .popover').removeClass('show');
        $('.cart-backdrop').removeClass('active');
        unlockBodyScroll();
        closeCart();
    });

    $(document).on('click', '.minicartFly .close[data-dismiss="alert"]', function (e) {
        e.preventDefault();
        $('.minicartFly .popover').removeClass('show');
        $('.cart-backdrop').removeClass('active');
        unlockBodyScroll();
        closeCart();
    });

    $('#backdrop').on('click', function () {
        $('.minicartFly .popover').removeClass('show');
        $('.cart-backdrop').removeClass('active');
        unlockBodyScroll();
        closeCart();
    });

    // Luk fly-in når man klikker på "keep-shopping" knappen i fly-in
    $(document).on('click', '.minicartFly a.keep-shopping', function (e) {
        e.preventDefault(); // fordi href="#"

        $('.minicartFly .popover').removeClass('show');
        $('.cart-backdrop').removeClass('active');
        unlockBodyScroll();
        if (typeof closeCart === 'function') closeCart();
    });

    // Erstat indhold ved ændring i kurv.
    function refreshMiniCartFly() {
        var url = $('.minicartFly').data('action-url');
        if (!url) return;

        var $popover = $('.minicartFly .popover');
        $popover.spinner && $popover.spinner().start();

        $.get(url, function (html) {
            var $html = $(html);

            var $newEstTotal = $html.find('.estimated-total');
            if ($newEstTotal.length) {
                var $target = $('.minicartFly .estimated-total');
                if ($target.length) {
                    $target.html($newEstTotal.html());
                } else {
                    var $footer = $('.minicartFly .minicart-footer');
                    if ($footer.length) {
                        var $existingEst = $footer.find('.estimated-total');
                        if ($existingEst.length) $existingEst.replaceWith($newEstTotal);
                        else $footer.append($newEstTotal);
                    }
                }
            } else {
                var newAmount = $html.find('.estimated-total strong').text();
                if (newAmount) $('.minicartFly .estimated-total strong').text(newAmount);
            }

            var $newFdMsg = $html.find('.fd-message');
            if ($newFdMsg.length) {
                var $fdTarget = $('.minicartFly .fd-message');
                if ($fdTarget.length) $fdTarget.html($newFdMsg.html());
                else {
                    var $footer2 = $('.minicartFly .minicart-footer');
                    if ($footer2.length) {
                        var $existingFd = $footer2.find('.fd-message');
                        if ($existingFd.length) $existingFd.replaceWith($newFdMsg);
                        else $footer2.append($newFdMsg);
                    } else {
                        $('.minicartFly').append($newFdMsg);
                    }
                }
            }

            var $newFdBar = $html.find('.fd-bar');
            if ($newFdBar.length) {
                var $fdBarTarget = $('.minicartFly .fd-bar');
                if ($fdBarTarget.length) $fdBarTarget.html($newFdBar.html());
                else {
                    var $footer3 = $('.minicartFly .minicart-footer');
                    if ($footer3.length) {
                        var $existingFdBar = $footer3.find('.fd-bar');
                        if ($existingFdBar.length) $existingFdBar.replaceWith($newFdBar);
                        else $footer3.append($newFdBar);
                    } else {
                        $('.minicartFly').append($newFdBar);
                    }
                }
            }
        }).always(function () {
            $.spinner && $.spinner().stop();
        });
    }

    $('body').on('change', '.minicartFly .quantity', function () {
        setTimeout(refreshMiniCartFly, 250);
    });

    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;

        // Sæt minicart count til 1 hvis den står på 0
        $('.minicart-quantity').each(function () {
            var current = parseInt($(this).text(), 10);
            if (isNaN(current) || current === 0) {
                $(this).text('1');
            }
        });

        openMiniCartFly(true);
    });

    $('body').on('cart:update', function () {
        updateMiniCart = true;

        var text = $.trim($('.minicart-quantity').first().text());
        var qty = parseInt(text, 10);

        if (!isNaN(qty)) {
            var label = 'Kurv ' + qty + (qty === 1 ? ' vare' : ' varer');
            applyMiniCartCount(qty, label);
        }

        if (!isNaN(qty) && qty === 0) {
            $('.minicartFly .popover').removeClass('show');
            $('.cart-backdrop').removeClass('active');
            unlockBodyScroll();
            if (typeof closeCart === 'function') closeCart();
        }
    });

    $('body').on('click', '.minicart .cart .minicart-top-part .minicart-error.cart-error .alert button', function () {
        $('.minicart-top-part').removeClass('higher');
    });

    $('body').on('click', '.product-move .move', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) return;

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: { pid: pid, optionId: optionId, optionVal: optionVal },
            success: function (data) {
                displayMessageAndRemoveFromCart(data);
                $('body').trigger('product:afterAddToCart', data);
                $('body').trigger('cart:update', data);
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });

    // =========================================================
    // HARD LOCK: ingen body-scroll når fly-in er åben (inkl. footer)
    // (én eneste touchmove handler)
    // =========================================================
    (function () {
        function isFlyInOpen() {
            return $('.cart-backdrop').hasClass('active') || $('.minicartFly .popover').hasClass('show');
        }

        function isInsideFlyInScrollableArea(target) {
            // Tillad kun scroll inde i fly-in indholdet (ikke footer)
            return $(target).closest('.minicartFly .minicart-top-part, .minicartFly .product-summary, .minicartFly .popover').length > 0
                && $(target).closest('.minicartFly .minicart-footer').length === 0;
        }

        document.addEventListener('touchmove', function (e) {
            if (!isFlyInOpen()) return;

            if (!isInsideFlyInScrollableArea(e.target)) {
                e.preventDefault();
                return;
            }

            if ($(e.target).closest('.minicartFly .minicart-footer').length) {
                e.preventDefault();
            }
        }, { passive: false });

        document.addEventListener('wheel', function (e) {
            if (!isFlyInOpen()) return;

            if (!isInsideFlyInScrollableArea(e.target)) {
                e.preventDefault();
            }
        }, { passive: false });
    })();
};

(function () {
    function setVisualViewportVars() {
        if (!window.visualViewport) return;

        var vv = window.visualViewport;

        // Synlig højde (det brugeren reelt kan se)
        document.documentElement.style.setProperty('--vvh', vv.height + 'px');

        // Hvor meget af bunden der er "overlappet" ift. layout viewport
        // (innerHeight er layout-viewport; vv.height er visual viewport)
        var bottomOverlap = Math.max(0, (window.innerHeight - vv.height - vv.offsetTop));
        document.documentElement.style.setProperty('--vvb', bottomOverlap + 'px');
    }

    setVisualViewportVars();

    // Chrome ændrer det her når adresse-/toolbar ændrer sig
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', setVisualViewportVars);
        window.visualViewport.addEventListener('scroll', setVisualViewportVars);
    }
    window.addEventListener('resize', setVisualViewportVars);
})();

window.openCart = function openCart() {
  $('html').addClass('cart-open');
  $('body').addClass('cart-open');
};

window.closeCart = function closeCart() {
  $('html').removeClass('cart-open');
  $('body').removeClass('cart-open');
};


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/miniCart.js